var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"v-loading"},[_c('div',{ref:"spinner",staticClass:"spinner",style:(_vm.spinnerStyleObj)},[_c('div',{staticClass:"quarter-circle",style:(_vm.circleStyleObj)})])])}
var staticRenderFns = []

export { render, staticRenderFns }